<template>
  <div class="exchange-rate" :class="{ 'visibility-hidden': !quote }">
    <p class="exchange exchange-rate--standard" v-if="selectedCurrency && quote && currencyIsAllowed && !(showLoyaltyCTA && isSignedInToLoyalty)">
      <b>{{ content.standardRateLabel || "Exchange rate" }}</b>
        £1 = {{ selectedCurrency.symbol
        }}{{ rate.toFixed(4) }}
    </p>
    <p class="exchange exchange-rate--loyalty" v-if="selectedCurrency && quote && currencyIsAllowed && showLoyaltyCTA && isSignedInToLoyalty">
      <b>{{ content.loyaltyRateLabel || "Loyalty rate" }}</b>
        £1 = {{ selectedCurrency.symbol
        }}{{ rate.toFixed(4) }}
    </p>

    <p class="no-exchange-allowed" v-if="selectedCurrency && quote && isSellTransaction && !selectedCurrency.purchaseAllowed">
      <span v-if="content.noPurchaseAllowedMessage">
        {{content.noPurchaseAllowedMessage.replace('{currency}', selectedCurrency.pluralName)}}
      </span>
      <span v-else>
        Oh snap! We don't have any {{selectedCurrency.pluralName}} right now - check back soon!
      </span>
    </p>

    <p class="no-exchange-allowed" v-if="selectedCurrency && quote && isBuyTransaction && !selectedCurrency.sellBackAllowed">
      <span v-if="content.noSellBackAllowedMessage">
        {{content.noSellBackAllowedMessage.replace('{currency}', selectedCurrency.pluralName)}}
      </span>
      <span v-else>
        Oh snap! We can't buy {{selectedCurrency.pluralName}} right now - check back soon!
      </span>
    </p>
    
    <LoyaltyCTA v-if="showLoyaltyCTA && !isSignedInToLoyalty" 
                :preamble="content.loyaltyCTAPreamble || 'Get a better rate by signing in'"
                :text="content.loyaltyCTAText || 'Sign In'" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { showInfo } from '@vue/services/toast.service';
import miscUtils from '@vue/utils/misc.utils';
import LoyaltyCTA from './loyalty-cta';

export default {
  name: 'ExchangeRate',
  components: {
    LoyaltyCTA
  },
  computed: {
    ...mapState({
      content: (state) => state.calculator.content,
      selectedCurrency: state => state.calculator.selectedCurrency,
      quote: state => state.calculator.quote,
      isSignedInToLoyalty: (state) => state.calculator.isSignedInToLoyalty
    }),
    ...mapGetters({
      hasSession: 'session/hasSession',
      tieredRate: 'calculator/tieredRate',
      isSellTransaction: 'calculator/isSellTransaction',
      isBuyTransaction: 'calculator/isBuyTransaction',
    }),
    rate() {
      return this.tieredRate.rate || this.quote.rate || 0
    },
    showLoyaltyCTA() {
      return window.calculatorSettings?.showLoyaltyCTA || false;
    },
    currencyIsAllowed() {
      return (this.isSellTransaction && this.selectedCurrency.purchaseAllowed) || (this.isBuyTransaction && this.selectedCurrency.sellBackAllowed);
    }
  },
  methods: {
    ...mapActions({
      getCalculatorContent: 'calculator/getCalculatorContent',
    })
  },
  async mounted() {
    await this.getCalculatorContent();

    if(this.hasSession && this.isSignedInToLoyalty && miscUtils.hasUrlParameter('signedIn')) {
      showInfo({ text: this.content?.loyaltySignedInToastText || "You've signed in" });
      miscUtils.removeUrlParameter('signedIn');
    }
  }
}
</script>
